export default function About() {
  return (
    <section id="about" className="py-32 bg-[#FAFAF8]">
      <div className="container mx-auto px-16">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-widest text-[#6B8E6B] mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
            Who We Are
          </p>
          <h3 className="text-5xl text-[#2A2A2A] leading-tight max-w-4xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            <span className="font-normal">Expert Team Building</span><br />
            <span className="font-bold">Premium iOS Applications</span><br />
            <span className="font-normal">for Enhanced Security</span>
          </h3>
          <p className="text-base text-[#6B6B6B] mt-6">
            Enhancing mobile security and user experience
          </p>
        </div>

        <div className="mt-24 max-w-4xl mx-auto">
          <p className="text-base text-[#6B6B6B] leading-relaxed text-center">
            SEMBODJA OOD is dedicated to creating innovative iOS applications that prioritize user privacy, device performance, and seamless functionality. Our products, including VPN and Cleaner applications, are meticulously crafted to provide users with powerful tools for protecting their digital lives and optimizing their mobile devices. With a focus on intuitive design and robust security features, we strive to deliver exceptional value to every user.
          </p>
        </div>
      </div>
    </section>
  );
}
